module.exports = __webpack_public_path__ + "img/gx.8c1147df.png";